// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7ad6bd1d","78":"2126fcfe","261":"8d25048c","747":"ef3e60de"}[chunkId] + ".chunk.js";
};